import type {ThemedVisual} from '../../../../Index.types'
import {BackgroundGrid} from '../../BackgroundGrid/BackgroundGrid'

import Styles from './FeatureGridVisual.module.css'

export interface FeatureGridVisualProps {
  visual: ThemedVisual
}

export const defaultProps: Partial<FeatureGridVisualProps> = {}

export const FeatureGridVisual = (props: FeatureGridVisualProps) => {
  const initializedProps: FeatureGridVisualProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return (
    <div className={Styles['FeatureGridVisual']}>
      <BackgroundGrid hasRoundedCorners hasRingShine />
    </div>
  )
}
